import React from 'react';
import styled from 'styled-components';

import { Row, Col } from 'components/layout';
import Statistics from 'components/Statistics';

import { monitorStat, monitorStatsDefaultProps } from '../constants';

const StatsSummaryTable = ({ loadingStats, unloadingStats, emptyValue }) => {
  function renderStat(stat, value) {
    const statProps = { ...monitorStatsDefaultProps[stat] };

    if (stat === monitorStat.NORMAL) {
      statProps.title = (
        <span style={{ display: 'inline-block', width: '8ch' }}>
          {statProps.title}</span>
      );
    }

    return (
      <StyledStatistics
        {...statProps}
        value={
          Number.isInteger(value)
            ? value
            : '-'
        }
        titleAlign={['center', 'right']}
      />
    );
  }

  return (
    <Row>
      {
        [monitorStat.NOT_STARTED, monitorStat.SLOW, monitorStat.NORMAL, monitorStat.FAST, monitorStat.STOPPED, monitorStat.FINISHED].map(stat => {
          const unloadingStat = unloadingStats.find(s => s.stat === stat);
          const loadingStat = loadingStats.find(s => s.stat === stat);

          const unloadingStatEl = renderStat(stat, unloadingStat.value);
          let loadingStatEl;

          if (stat === monitorStat.NORMAL) {
            const normalValue = loadingStats.find(s => s.stat === monitorStat.NORMAL).value;
            loadingStatEl = renderStat(monitorStat.NORMAL, normalValue);
          } else {
            loadingStatEl = renderStat(stat, loadingStat.value);
          }

          return (
            <Col key={stat}>
              <Row justify='end' style={{ height: '50%' }}>
                {unloadingStatEl}
              </Row>
              <Row justify='end' style={{ height: '50%' }}>
                {loadingStatEl}
              </Row>
            </Col>
          );
        })
      }
      <Col>
        <Row align='middle' justify='end' style={{ height: '100%' }}>
          <StyledStatistics
            title="Empty"
            color="#828C94"
            value={
              Number.isInteger(emptyValue)
                ? emptyValue
                : '-'
            }
            titleAlign={['center', 'right']}
          />
        </Row>
      </Col>
    </Row>
  );
}

const StyledStatistics = styled(Statistics)`
  line-height: 5vh;
  margin-left: 2.3vw;
  text-align: right;

  & .ant-statistic-title {
    font-style: normal;
    font-weight: bold;
    font-size: 1.24vw;
    color: #45494D;
    text-align: start;
    margin-bottom: unset;
    color: ${props => props.color};
  }

  & .ant-statistic-content {
    margin-right: 0.4vw;
    font-style: normal;
    font-weight: bold;
    font-size: 1.74vw;
    color: ${props => props.color};
  }
`;


export default StatsSummaryTable;